import React from 'react';

const WhyChooseUs = () => {
  const pillars = [
    {
      emoji: '🤝',
      title: 'Empowering Candidates',
      body: 'Craft standout resumes and career strategies tailored to your unique goals, ensuring you land your dream job.',
    },
    {
      emoji: '🏢',
      title: 'HR Business Solutions',
      body: 'Streamline hiring with expert consultation, from talent acquisition strategies to optimized recruitment processes.',
    },
    {
      emoji: '🚀',
      title: 'Dual Expertise',
      body: 'Uniquely positioned to bridge candidates and businesses, delivering impactful results for both with industry insights.',
    },
  ];

  return (
    <section className="bg-slate-50">
      {/* subtle parallax background pattern */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23000\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 py-20 lg:py-32">
        <header className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">
            Why <span style={{ color: '#0e6d87' }}>Navam</span>?
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-600">
            Your trusted partner for job seekers and HR solutions, delivering excellence on both fronts.
          </p>
        </header>

        {/* cards */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((p, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 p-8 text-center"
            >
              <div
                className="inline-flex items-center justify-center w-20 h-20 rounded-full text-white text-3xl shadow-md group-hover:scale-110 transition-transform"
                style={{ background: 'linear-gradient(135deg,#0e6d87,#0a4f5f)' }}
              >
                {p.emoji}
              </div>
              <h3 className="mt-6 text-2xl font-bold text-slate-900">
                {p.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;